import React from 'react';
import { protectedRoute } from '@/modules/core/root/protected/route';
import { createRoute } from '@tanstack/react-router';

export const fleetRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'fleet',
  wrapInSuspense: true,
  component: React.lazy(async () => await import('@/app/routes/Fleet')),
});
